export default __webpack_public_path__ + "static/media/user_ic.dad123bd.svg";